import { Link as RouterLink } from 'react-router-dom';

import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Grid,
    Pagination,
    Rating,
    Stack,
    Typography
} from '@mui/material';

import {
    formatReviewDate,
    productPath
} from './reviewViewHelpers';

const PendingReviewList = ({
    error,
    loading,
    onPageChange,
    onReview,
    pagination,
    products
}) => {
    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error)
        return <Alert severity="error">{error}</Alert>;

    if (products.length < 1) {
        return (
            <Alert severity="success">
                No tienes productos pendientes por reseñar.
            </Alert>
        );
    }

    return (
        <>
            <Grid container spacing={2}>
                {products.map(item => {
                    const path = productPath(item.product);

                    return (
                        <Grid item xs={12} md={6} key={item.variant.id}>
                            <Card
                                variant="outlined"
                                sx={{ height: '100%' }}
                            >
                                <CardContent>
                                    <Stack
                                        direction={{ xs: 'column', sm: 'row' }}
                                        spacing={2}
                                    >
                                        <Box
                                            component="img"
                                            src={item.product.image_url}
                                            alt={item.product.title}
                                            loading="lazy"
                                            sx={{
                                                height: 120,
                                                objectFit: 'contain',
                                                width: { xs: '100%', sm: 120 }
                                            }}
                                        />
                                        <Box sx={{ flex: 1 }}>
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight="bold"
                                            >
                                                {item.product.title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                {item.variant.title ||
                                                    'Presentación única'}
                                            </Typography>
                                            <Stack
                                                direction="row"
                                                flexWrap="wrap"
                                                gap={1}
                                                sx={{ mt: 1 }}
                                            >
                                                <Chip
                                                    color="success"
                                                    label="Compra verificada"
                                                    size="small"
                                                    variant="outlined"
                                                />
                                                {item.purchase_count > 1 &&
                                                    <Chip
                                                        label={`Comprado ${
                                                            item.purchase_count
                                                        } veces`}
                                                        size="small"
                                                        variant="outlined"
                                                    />
                                                }
                                            </Stack>
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                display="block"
                                                sx={{ mt: 1 }}
                                            >
                                                Pedido ONL-{item.order.number} · {
                                                    formatReviewDate(
                                                        item.order.purchased_at
                                                    )
                                                }
                                            </Typography>
                                            <Typography
                                                component="legend"
                                                variant="body2"
                                                sx={{ mt: 2 }}
                                            >
                                                ¿Qué calificación le das?
                                            </Typography>
                                            <Rating
                                                value={0}
                                                onChange={(event, value) => {
                                                    if (value)
                                                        onReview(item, value);
                                                }}
                                                aria-label={`Calificar ${
                                                    item.product.title
                                                }`}
                                            />
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                sx={{ mt: 2 }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    onClick={() => onReview(item, 0)}
                                                >
                                                    Escribir reseña
                                                </Button>
                                                {path &&
                                                    <Button
                                                        component={RouterLink}
                                                        to={path}
                                                        variant="text"
                                                    >
                                                        Ver producto
                                                    </Button>
                                                }
                                            </Stack>
                                        </Box>
                                    </Stack>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
            {pagination.pages > 1 &&
                <Stack alignItems="center" sx={{ mt: 3 }}>
                    <Pagination
                        count={pagination.pages}
                        page={pagination.page}
                        onChange={(event, page) => onPageChange(page)}
                    />
                </Stack>
            }
        </>
    );
};

export default PendingReviewList;
